import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DataProvider } from './src/context/DataContext';
import { Layout } from './src/components/layout/Layout';
import { Dashboard } from './src/pages/Dashboard';
import { Customers } from './src/pages/Customers';
import { Invoices } from './src/pages/Invoices';
import { InvoiceForm } from './src/pages/InvoiceForm';
import { Subscriptions } from './src/pages/Subscriptions';
import { SubscriptionForm } from './src/pages/SubscriptionForm';
import { Settings } from './src/pages/Settings';
export function App() {
  return <DataProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Layout data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<Dashboard data-id="element-5" />} data-id="element-4" />
            <Route path="/customers" element={<Customers data-id="element-7" />} data-id="element-6" />
            <Route path="/invoices" element={<Invoices data-id="element-9" />} data-id="element-8" />
            <Route path="/invoices/new" element={<InvoiceForm data-id="element-11" />} data-id="element-10" />
            <Route path="/invoices/:id" element={<InvoiceForm data-id="element-13" />} data-id="element-12" />
            <Route path="/subscriptions" element={<Subscriptions data-id="element-15" />} data-id="element-14" />
            <Route path="/subscriptions/new" element={<SubscriptionForm data-id="element-17" />} data-id="element-16" />
            <Route path="/subscriptions/:id" element={<SubscriptionForm data-id="element-19" />} data-id="element-18" />
            <Route path="/settings" element={<Settings data-id="element-21" />} data-id="element-20" />
          </Routes>
        </Layout>
      </BrowserRouter>
    </DataProvider>;
}